module.exports = __webpack_public_path__ + "b4bad739f6ca0d06765b74a5801efd0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-gamer.png
// module id = 1566
// module chunks = 0